<template>

<div>

      <app-navigator  @typeChenge="ParsContent = $event" :leftMenu='leftMenu' > </app-navigator>

      <v-container fluid >
        <router-view :key="$route.fullPath"></router-view>
     </v-container>
</div>

</template>

<script>




export default {
  data () {
    return {
      leftMenu: {
        title: "Ресурсы",
        items: [
         {name:"Таблица аккаунтов", icon:"mdi-tune", iconColor:"green" , count:"", content:"accounts_info", selected:false },

         {content:"line"},
         {name:"Основной список", icon:"mdi-account-switch", iconColor:"#273C51" , count:"vk_profiles", content:"accounts", selected:true },
         {name:"Автореги список", icon:"mdi-account-switch", iconColor:"#273C51" , count:"vk_profiles_autoreg", content:"autoreg_accounts", selected:false },
         {name:"Друзья список", icon:"mdi-account-switch", iconColor:"#273C51" , count:"vk_profiles_friends", content:"friends_accounts", selected:false },
         {name:"Другое список", icon:"mdi-account-switch", iconColor:"#273C51" , count:"vk_profiles_others", content:"others_accounts", selected:false },


         {content:"line"},
         {name:"Antigate", icon:"mdi-robot",iconColor:"yellow" , content:"antigate", selected:false },
         {name:"Telegram tools", icon:"mdi-telegram",iconColor:"blue" , content:"telega", selected:false },


        ]
      }
    }
  },


}
</script>

<style scoped >
  #content {

  }
</style>
